import { styled } from '@mui/material/styles'

export const Root = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`
